<template>
    <div class="content">
        <headers :title='titles'></headers>
        <div v-if="!firstLoad">
            <div v-if="Object.keys(book).length==0">
                <div class="box">
                    <p class="p1"></p>
                    <p class="p2">您暂未设置<em>教材</em></p>
                    <p class="p3">请设置一本<em>教材</em>吧，设置过后才能布置作业</p>
                    <a href="javascript:;"
                       class="set-book"
                       @click="setbook">设置教材</a>
                </div>
            </div>
            <div v-else>
                <div class="title">
                    <div>
                        <p></p>
                        <p>{{book.name}}</p>
                        <p @click="setbook">更换<em>教材</em></p>
                        <p></p>
                    </div>
                </div>
                <div class="main"
                     v-if="list.length >0">
                    <div class="main_box"
                         v-for="(i,index) in list">
                        <div class="main_title"
                             @click="open(i,index)">
                            <p><i></i></p>
                            <p>{{i.name}}</p>
                            <p :class="i.choise ? 'list_open' : 'list_close'"
                               v-if="i.children.length >0"></p>
                        </div>
                        <transition name="my-slide"
                                    tag="div">
                            <div class="main_con_wrap"
                                 v-show="!i.choise"
                                 :style="`height:${i.children.length * 2.425}rem`">
                                <div class="main_con"
                                     v-for="q,inx in i.children">
                                    <p>{{q.name}}</p>
                                    <p class="btn_list">
                                        <span class="btn"
                                              @click="release(q,inx)">布置</span>
                                        <span class="btn"
                                              @click="view(q)">查看作品</span>
                                    </p>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
                <div v-else>
                    <noResouse></noResouse>
                </div>
            </div>
        </div>
        <div v-else>
            <loading></loading>
        </div>
        <div class="select_mask"
             v-if="show_select_class">
            <div class="select_class">
                <div class="tit"> 选择班级 </div>
                <div class="tips">请选择您要布置的班级</div>
                <p class="unit_item"
                   v-for="(item,index) in sf_class"
                   :class="active_unit_class.unit_class_id==item.unit_class_id?'active':''"
                   @click="select_class(item)"
                   :key="index"><span>{{item.unit_name}}</span></p>
                <div class="btn_list">
                    <span @click="shure"
                          :class="!active_unit_class.unit_class_id?'gray':''">确定</span>
                    <span @click="cancel">取消</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import { mapState } from 'vuex';
import loading from 'COMPONENTS/base/loadingS.vue';
import noResouse from 'COMPONENTS/noResouse.vue'
import headers from 'COMPONENTS/base/header.vue'

export default {
    data () {
        return {
            type: this.$route.params.type,
            hasbook: false,
            firstLoad: true,
            list: [],
            book: [],
            titles: '书法同步练习',
            show_select_class: false,
            sf_class: [],//书法班级
            active_chapter: {},//选中的章节
            active_unit_class: {},//选中的班级
        }
    },
    components: {
        loading,
        noResouse,
        headers
    },
    computed: {},
    watch: {},
    async created () {
        let _sendok = localStorage.getItem('chinese_send_ok');
        if (_sendok == 1) {
            this.$router.go(-1);//发布过返回选内容
            return;
        }
        let o = {
            sid: 51,
            book_type: 0,  //0-教材,1-教辅 默认教材
            code: '013'
        }
        await this.$http.post(API_URL_TASK_API + '/public/book/user_book', o).then(resp => {
            let res = resp.data;
            if (res.response === 'ok') {
                this.$store.state.book = res.data;
                this.book = res.data
            }
        })

        if (Object.keys(this.book).length != 0) {
            await this.getlist();
        } else {
            this.firstLoad = false
        }
    },
    methods: {
        setbook () {
            this.$router.push('/setBook/51/1/13')
        },
        getlist () {
            if (Object.keys(this.book).length != 0) {
                this.$http.post(API_URL_TASK_API + '/chinese/check/chapter/list', {
                    book_id: this.book.id,
                }).then(resp => {
                    let res = resp.data;
                    this.firstLoad = false
                    if (res.response === 'ok') {
                        this.list = res.data;
                        this.list.forEach((l, index) => {
                            l.choise = true;

                        })
                    }
                })
            } else {
                this.firstLoad = false
            }
        },
        open (i, ind) {
            i.choise = !i.choise
            this.list.splice(ind, 1, i)
        },


        back () {
            this.$router.go(-1)
        },
        //布置作业
        release (q, inx) {
            this.active_chapter = q
            //先获取所有班级
            let all_class = JSON.parse(localStorage.getItem('info')).units
            //过滤出书法班级
            this.sf_class = all_class.filter(item => item.sid == 11 || item.sid == 14)
            this.show_select_class = true

        },
        //查看作业
        view (q) {
            this.$router.push('/activity/2023sfhd/view/' + q.ch_id + '?chapter_name=' + encodeURIComponent(q.name))
        },
        //生成分享到短链
        select_class (item) {
            this.active_unit_class = item
        },
        /**点击确定获取分享短链地址 */
        shure () {
            let that = this
            if (!this.active_unit_class.unit_class_id) {
                return
            }
            console.log('选中的章节ID：', this.active_chapter)
            console.log('选中的班级：', this.active_unit_class)
            let share_url = `${VUE_URL_HD}#/active/2023sfhd/release/${this.active_unit_class.unit_class_id}/${this.active_chapter.ch_id}?grade_id=${this.active_unit_class.grade_id}&class_name=${encodeURIComponent(this.active_unit_class.unit_name)}&chapter_name=${encodeURIComponent(this.active_chapter.name)}`
            this.$http.post(API_URL_SORT_API + '/create_sort/', {
                url: share_url,
                sort_type: 2
            }).then((res) => {
                if (res.data.response === 'ok') {

                    let short_url = res.data.data.short_url
                    let coptText = `${this.active_unit_class.unit_name}的各位家长好，今日的书法同步练习作业已发布，点击链接即可查看，链接：${short_url}`

                    layer.alert('将链接粘贴并发送到对应的班级群，家长点击链接即可。', 'tea', function (index) {
                        that.copyText(coptText);
                        layer.close(index)
                    }, '分享链接复制成功')
                    this.show_select_class = false
                    this.cancel()
                }
            })
        },
        cancel () {
            this.show_select_class = false
            this.active_unit_class = {}
        },


        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.set-book {
    display: block;
    margin: 40px / $ppr auto 0 auto;
    width: 360px / $ppr;
    height: 82px / $ppr;
    line-height: 82px / $ppr;
    font-size: 30px / $ppr;
    color: #fff;
    background: #5e89ef;
    border-radius: 41px / $ppr;
    text-align: center;
}

.content {
    width: 100%;
    min-height: calc(100vh - 2.375rem);
    .title {
        width: 100%;
        height: 96px / $ppr;
        margin-bottom: 24px / $ppr;
        background: #fff;
        div {
            width: 673px / $ppr;
            height: 96px / $ppr;
            margin: 0 auto;
            p {
                line-height: 96px / $ppr;
                text-align: left;
            }
            p:nth-child(1) {
                width: 34px / $ppr;
                height: 34px / $ppr;
                background: url("img/icon_setbook.png") no-repeat;
                -webkit-background-size: 100% 100%;
                background-size: 100% 100%;
                float: left;
                margin: 31px / $ppr 24px / $ppr 0 0;
            }
            p:nth-child(2) {
                width: 462px / $ppr;
                float: left;
                font-size: 30px / $ppr;
                color: #333;
                @include ellipsis;
            }
            p:nth-child(3) {
                width: 139px / $ppr;
                color: #5e89ef;
                font-size: 30px / $ppr;
                float: left;
            }
            p:nth-child(4) {
                width: 14px / $ppr;
                height: 26px / $ppr;
                float: right;
                margin-top: 34px / $ppr;
                background: url("./img/enter.png") no-repeat;
                -webkit-background-size: 100% 100%;
                background-size: 100% 100%;
            }
        }
    }
    .main {
        width: 100%;
        height: auto;
        background: #fff;
        .main_box {
            width: 100%;
            height: auto;
            &:last-child .main_title {
                border-bottom: none !important;
            }
            .main_title {
                width: 100%;
                height: 96px / $ppr;
                border-bottom: 1px / $ppr solid #e8e8e8;
                p:nth-child(1) {
                    width: 80px / $ppr;
                    height: 96px / $ppr;
                    float: left;
                    i {
                        display: block;
                        width: 34px / $ppr;
                        height: 32px / $ppr;
                        background: url("img/icon_book.png") no-repeat;
                        -webkit-background-size: 100% 100%;
                        background-size: 100% 100%;
                        margin: 32px / $ppr 22px / $ppr 0 24px / $ppr;
                    }
                }
                p:nth-child(2) {
                    width: 556px / $ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    font-size: 30px / $ppr;
                    color: #333;
                    float: left;
                    text-align: left;
                    @include ellipsis;
                }
                .list_open {
                    width: 25px / $ppr;
                    height: 13px / $ppr;
                    background: url("img/icon_open.png") no-repeat;
                    -webkit-background-size: 100% 100%;
                    background-size: 100% 100%;
                    float: right;
                    margin: 41px / $ppr 24px / $ppr 0 0;
                }
                .list_close {
                    width: 25px / $ppr;
                    height: 13px / $ppr;
                    background: url("img/icon_close.png") no-repeat;
                    -webkit-background-size: 100% 100%;
                    background-size: 100% 100%;
                    float: right;
                    margin: 41px / $ppr 24px / $ppr 0 0;
                }
            }
            .main_con {
                width: 100%;
                height: 96px / $ppr;
                background: #f0f0f0;
                border-bottom: 1px / $ppr solid #e8e8e8;
                p {
                    float: left;
                    box-sizing: border-box;
                }
                p:nth-child(1) {
                    margin-left: 106px / $ppr;
                    line-height: 96px / $ppr;
                    color: #333;
                    font-size: 30px / $ppr;
                    text-align: left;
                    @include ellipsis;
                    max-width: 310px;
                }
                p:nth-child(2) {
                    height: 100%;
                    line-height: 96px / $ppr;
                    text-align: right;
                    color: #5e89ef;
                    font-size: 28px / $ppr;
                    float: right;
                }
                .btn {
                    display: inline-block;
                    width: 132px / $ppr;
                    line-height: 48px / $ppr;
                    text-align: center;
                    background: #5e89ef;
                    border-radius: 48px / $ppr;
                    color: #fff;
                    margin-right: 16px / $ppr;
                    font-size: 24px / $ppr;
                }
            }
        }
    }
}

.box {
    //无教材
    width: 100%;
    height: auto;
    margin-top: 325px / $ppr;
    p {
        display: block;
    }
    .p1 {
        width: 136px / $ppr;
        height: 112px / $ppr;
        background: url("img/icon_nobook.png") no-repeat;
        -webkit-background-size: 100% 100%;
        background-size: 100% 100%;
        margin: 0 auto;
    }
    .p2 {
        width: 100%;
        text-align: center;
        color: #333;
        font-size: 36px / $ppr;
        line-height: 36px / $ppr;
        margin: 40px / $ppr 0 16px / $ppr 0;
    }
    .p3 {
        width: 100%;
        text-align: center;
        color: #999;
        font-size: 24px / $ppr;
        line-height: 24px / $ppr;
        margin-bottom: 40px / $ppr;
    }
    .p4 {
        width: 360px / $ppr;
        height: 82px / $ppr;
        margin: 0 auto;
        border-radius: 40px / $ppr;
        background: #5e89ef;
        font-size: 34px / $ppr;
        color: #fff;
        line-height: 82px / $ppr;
    }
}

.foot {
    position: fixed;
    bottom: 0;
    width: 100%;
    .bottom_btn {
        a {
            display: inline-block;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            width: 100%;
            color: #999999;
            background-color: $line;
            text-align: center;
            font-size: 36px / $ppr;
            //font-weight: bold;
            &.btn_a {
                color: #fff;
                background-color: #5e89ef;
            }
        }
    }
    .bottom_btn2 {
        a {
            display: inline-block;
            height: 97px / $ppr;
            line-height: 97px / $ppr;
            width: 100%;
            color: $c-header;
            background-color: $c-theme;
            text-align: center;
            font-size: $lg;
        }
    }
}
.main_con_wrap {
    height: 0;
    transition: height 0.3s linear;
    overflow: hidden;
}
.my-slide-enter,
.my-slide-leave-to {
    height: 0 !important;
}
.select_mask {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    z-index: 99;
    .select_class {
        position: absolute;
        top: 50%;
        left: 10%;
        right: 10%;
        transform: translateY(-50%);
        background: #fff;
        border-radius: 10px / $ppr;
        .tit {
            font-size: 32px / $ppr;
            font-weight: bold;
            color: #333;
            text-align: center;
            margin-top: 67px / $ppr;
        }
        .tips {
            text-align: center;
            font-size: 28px / $ppr;
            margin-top: 28px / $ppr;
            margin-bottom: 60px / $ppr;
            color: #666;
            &:before,
            &:after {
                content: "";
                width: 8px;
                height: 2px;
                background: #999;
                display: inline-block;
                vertical-align: middle;
                margin: -3px 5px 0;
            }
        }
        .unit_item {
            text-align: center;
            line-height: 80px / $ppr;
            border-radius: 80px / $ppr;
            background: #eff3fd;
            margin: 24px / $ppr 68px / $ppr 24px / $ppr;
            span {
                display: inline-block;
                font-size: 28px / $ppr;
                color: #5e89ef;
                font-weight: bold;
            }
            &.active {
                background: #5e89ef;
                span {
                    color: #fff;
                }
            }
        }
        .btn_list {
            text-align: center;
            border-top: 1px / $ppr solid #b5b5b5;
            margin-top: 60px / $ppr;
            span {
                width: 50%;
                box-sizing: border-box;
                display: inline-block;
                font-size: 30px / $ppr;
                color: #333;
                padding: 34px / $ppr 0;
                border-left: 1px / $ppr solid #b5b5b5;
                &:first-child {
                    border-left: 0;
                    color: #5e89ef;
                }
                &.gray {
                    color: #999;
                }
            }
        }
    }
}
</style>
